import React, {useState} from 'react'
import {usePagination, useRowSelect, useTable} from "react-table";
import {IndeterminateCheckbox} from "./IndeterminateCheckbox";
import {IconButton} from "@material-ui/core";
import {Delete, Edit} from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import TableBody from "@material-ui/core/TableBody";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import apiHelper from "../../../../../util/ApiHelper";
import {toast} from "react-toastify";

export const EventCategoryListingTable = ({
                                            match,
                                            disabled,
                                            data,
                                            setData,
                                            totalPages,
                                            totalElements,
                                            classes,
                                            singleDelete,
                                            bulkDelete,
                                            search,
                                            setPage,
                                            setRowsPerPage,
                                            // saveOrdering, // 不需要，此页面拖拽后自动保存
                                            displayAll,
                                            setDisplayAll
                                          }) => {

  const [keyword, setKeyword] = React.useState('')
  const [actionType, setActionType] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const refreshData = async () => {
    setIsLoading(true);
    try {
      const response = await apiHelper.hkiff.getEventCategories(1, 100);
      if (response.data.code === 0) {
        setData(response.data.data.records);
      }
    } catch (err) {
      console.error("Refresh Data Error:", err);
    } finally {
      setIsLoading(false);
    }
  };
  
  // 使用传入的search prop，如果为空则使用默认实现
  const handleSearch = async (keyword) => {
    if (keyword === "") {
      await refreshData();
      setOrderingDisabled(false);
    } else {
      setIsLoading(true);
      setOrderingDisabled(true);
      try {
        const response = await apiHelper.hkiff.getEventCategories(1, 100, keyword);
        if (response.data.code === 0) {
          setData(response.data.data.records);
        }
      } catch (err) {
        console.error("Search Error:", err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  // for Drag & Drop
  const [isDragging, setIsDragging] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);

  const onBeforeDragStart = () => {

  };

  const getMaxSeqInRows = (rows) => {
    let sequence = null;
    rows.forEach((e) => {
      if (
        (e.sequence && sequence === null) ||
        (sequence !== null && e.sequence > sequence)
      ) {
        sequence = e.sequence;
      }
    });
    return sequence;
  };

  const onDragEnd = (result) => {
    setIsDragging(false);
    
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    
    const items = reorder(data, result.source.index, result.destination.index);
    console.log("ON DRAG END:", items);
    setData(items);
  };
  
  // Save ordering function
  const saveOrdering = async () => {
    try {
      const seqData = {};
      data.forEach((e, i) => {
        seqData[e.id] = i + pageSize * pageIndex;
      });
      const result = await apiHelper.hkiff.orderEventCategories(seqData);
      
      if (result.data.code === 0) {
        toast.dark("Your changes are saved.");
        refreshData();
      }
    } catch (err) {
      console.error("Save Ordering err:", err);
      toast.error("Failed to save ordering.");
    }
  };

  const handleSelectChange = (e) => {
    setActionType(e.target.value);
  };


  /** DRAG N DROP PREPARATION STARTS **/

  const IsDraggingContext = React.createContext(false);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  class DraggableTableCell extends React.Component {
    getSnapshotBeforeUpdate(prevProps) {
      if (!this.ref) {
        return null;
      }
      const isDragStarting =
        this.props.isDragOccurring && !prevProps.isDragOccurring;
      if (!isDragStarting) {
        return null;
      }
      const {width, height} = this.ref.getBoundingClientRect();
      const snapshot = {
        width,
        height,
      };
      return snapshot;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      const ref = this.ref;
      if (!ref) {
        return;
      }
      if (snapshot) {
        if (ref.style.width === snapshot.width) {
          return;
        }
        ref.style.width = `${snapshot.width}px`;
        ref.style.height = `${snapshot.height}px`;
        return;
      }
      if (this.props.isDragOccurring) {
        return;
      }
      // inline styles not applied
      if (ref.style.width == null) {
        return;
      }
      // no snapshot and drag is finished - clear the inline styles
      ref.style.removeProperty("height");
      ref.style.removeProperty("width");
    }

    setRef = (ref) => {
      this.ref = ref;
    };

    render() {
      return (
        <TableCell
          style={{paddingTop: 6, paddingBottom: 6, lineHeight: "1.1em", height: "48px"}}
          ref={this.setRef}
          align={this.props.align}
          className={this.props.className}
        >
          {this.props.children}
        </TableCell>
      );
    }
  }

  const DraggableTableRow = ({snapshot, data, row, provided, className, orderingDisabled}) => {
    return (
      <IsDraggingContext.Consumer>
        {(isDragging) => (
          <TableRow
            className={className}
            ref={provided.innerRef}
            {...provided.draggableProps}
            style={{
              ...provided.draggableProps.style,
              background: snapshot.isDragging ? "#f5f5f5" : "white",
            }}
          >
            {row.cells.map((cell, index) => {
              if (cell.column.id !== "dragHandle") {
                return (
                  <DraggableTableCell 
                    key={index}
                    isDragOccurring={isDragging} 
                    scope="row"
                    className={cell.column.className}
                  >
                    {cell.render("Cell")}
                  </DraggableTableCell>
                );
              } else {
                return null;
              }
            })}
            <TableCell
              style={{paddingTop: 6, paddingBottom: 6, color: "#CCCCCC", cursor: "grab", lineHeight: "1.1em", height: "48px"}}
              {...(!orderingDisabled && {...provided.dragHandleProps})}
            >
              <DragHandleIcon/>
            </TableCell>
          </TableRow>
        )}
      </IsDraggingContext.Consumer>
    );
  };

  /** DRAG N DROP PREPARATION ENDS **/

  const CustomLink = React.useMemo(
    () =>
      React.forwardRef((linkProps, ref) => <Link
        ref={ref} {...linkProps} />),
    []
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "nameEn",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({row}) => {
          switch (row.original.status) {
            default:
            case false:
              return <span
                className={classes.text}>Inactive</span>
            case true:
              return <span
                className={classes.text}>Active</span>
          }
        },
      },
      {
        Header: "Last Updated",
        accessor: "updateTime",
      }
    ],
    []
  )

  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow,
    setPageSize,
    gotoPage,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    selectedFlatRows,
    state: {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      initialState: {pageIndex: 0, pageSize: 10},
      manualPagination: true,
      pageCount: totalPages,
    },
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({getToggleAllRowsSelectedProps}) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({row}) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
        {
          id: "action",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: () => <div>Action</div>,
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({row}) => (
            <div
              style={{display: "inline-flex"}}>
              <IconButton
                className={classes.iconBtn}
                size="small"
                component={CustomLink}
                to={`${match.url}/category/${row.original.id}`}
              >
                <Edit fontSize="small"/>
              </IconButton>
              {disabled || (
                <IconButton
                  className={classes.iconBtn}
                  size="small"
                  onClick={() => {
                    singleDelete(row.original.id);
                  }}
                >
                  <Delete
                    fontSize="inherit"/>
                </IconButton>
              )}
            </div>
          ),
        },
        // The drag handle can be used to drag the table's rows individually
        {
          id: "dragHandle",
          Header: () => <></>,
        },
      ]);
    }
  );

  const handleBulkAction = React.useCallback(async () => {
    switch (actionType) {
      case "DELETE":
        const ids = selectedFlatRows.map((o) => o.original.id);
        if (ids.length > 0) {
          try {
            await bulkDelete(ids);
          } catch (e) {
            console.log(e);
          }
        }
        break;
      default:
        break;
    }
  }, [actionType, bulkDelete, selectedFlatRows]);

  React.useEffect(() => {
    setRowsPerPage(pageSize);
  }, [pageSize]);

  React.useEffect(() => {
    setPage(pageIndex);
  }, [pageIndex]);

  return (
    <>
      <Grid
        container
        justify="space-between"
        style={{padding: "0 25px 10px"}}
      >
        <Grid container item xs={6} md={6}>
          <Box
            width="100%"
            component="span"
            display="flex"
            alignItems="center"
          >
            <Box flex>
              <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel id="demo-simple-select-outlined-label">
                  Bulk Actions
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={actionType}
                  onChange={handleSelectChange}
                  label="Bulk Actions"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"DELETE"}>Delete</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box flex>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleBulkAction}
                disabled={disabled}
              >
                Apply
              </Button>
            </Box>
            <Box display="flex" mr={2}>
              <Button
                variant="contained"
                color="primary"
                type="button"
                onClick={saveOrdering}
                disabled={disabled || isDragging || orderingDisabled}
              >
                Save Changes
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid container item xs={6} md={6}>
          <Box
            width="100%"
            component="span"
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            
            <Box display="flex">
              <Button
                variant="contained"
                color="primary"
                type="button"
                component={Link}
                disabled={disabled}
                to={`${match.url}/category/new`}
              >
                Add New Category
              </Button>
            </Box>
            <Box display="flex">
              <TextField
                id="outlined-error"
                label="Search"
                variant="outlined"
                margin="dense"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
              />
            </Box>
            <Box display="flex">
              <Button
                variant="outlined"
                color="primary"
                type="button"
                margin="dense"
                onClick={() => {
                    if (keyword === "") {
                      setOrderingDisabled(false);
                    } else {
                      setOrderingDisabled(true);
                    }
                    // 调用我们的搜索函数
                    handleSearch(keyword);
                  }}
              >
                Search
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container xs={12}>
        <IsDraggingContext.Provider value={isDragging}>
          <TableContainer
            component={Paper}
            style={{
              margin: "0 25px",
              boxShadow: "none",
              border: "1px solid #cccccc",
            }}
          >
            <fieldset disabled={disabled} className="fieldset">
              <Table
                aria-label="simple table"
                component="ul"
                style={{margin: "0"}}
                {...getTableProps()}
              >
                <colgroup>
                  <col style={{width: "5%"}}/>
                  <col style={{width: "40%"}}/>
                  <col style={{width: "20%"}}/>
                  <col style={{width: "20%"}}/>
                  <col style={{width: "10%"}}/>
                  <col style={{width: "5%"}}/>
                </colgroup>
                <TableHead component="div">
                  {headerGroups.map((headerGroup) => (
                    <TableRow {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <TableCell
                          {...column.getHeaderProps()}
                          className={`${column.className ?? ""}`}
                          style={{
                            paddingTop: 6,
                            paddingBottom: 6,
                            lineHeight: "1.1em",
                            height: "48px",
                          }}
                        >
                            <span>
                              {column.render("Header")}
                            </span>
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableHead>
                <DragDropContext
                  onBeforeDragStart={onBeforeDragStart}
                  onDragEnd={onDragEnd}
                >
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                      <TableBody
                        component="div"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {rows.map((row, index) => {
                          prepareRow(row);
                          return (
                            <Draggable
                              key={row.original.id}
                              draggableId={String(row.original.id)}
                              index={index}
                              isDragDisabled={disabled || orderingDisabled}
                            >
                              {(provided, snapshot) => (
                                <DraggableTableRow
                                  key={row.original.id}
                                  data={row.original}
                                  row={row}
                                  provided={provided}
                                  snapshot={snapshot}
                                  orderingDisabled={orderingDisabled}
                                />
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
              </Table>
            </fieldset>
          </TableContainer>
        </IsDraggingContext.Provider>
      </Grid>
      <Grid container justify="flex-end"
            style={{
              paddingLeft: "25px",
              marginTop: "15px"
            }}>
        <Grid container item xs={4}>
        </Grid>
        <Grid
          container
          item
          xs={8}
          justify="flex-end"
          style={{
            paddingRight: "25px",
            marginTop: "15px",
          }}
        >
          <div className={classes.flexRow}>
            <div></div>
            <div className={classes.pagination}>
                <span
                  className={classes.displayAllBtn}
                  onClick={() => {
                    setDisplayAll(!displayAll);
                  }}
                >
                  Turn {displayAll ? "Off" : "On"} Display All
                </span>

              {!displayAll && (
                <>
                  Show rows:{" "}
                  <TextField
                    id="page-rows"
                    select
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(Number(e.target.value));
                    }}
                    variant="outlined"
                    style={{minWidth: "70px"}}
                  >
                    {[5, 10, 25].map((pageSize) => (
                      <MenuItem key={pageSize} value={pageSize}>
                        {pageSize}
                      </MenuItem>
                    ))}
                  </TextField>
                  Go to{" "}
                  <TextField
                    id="pagination-field"
                    variant="outlined"
                    onChange={(e) => {
                      const page = e.target.value
                        ? Number(e.target.value) - 1
                        : 0;
                      gotoPage(page);
                    }}
                  />
                  {pageIndex * pageSize + 1} to{" "}
                  {(pageIndex + 1) * pageSize > totalElements
                    ? totalElements
                    : (pageIndex + 1) * pageSize}{" "}
                  of {totalElements}
                  <Button
                    onClick={() => {
                      previousPage();
                    }}
                    disabled={!canPreviousPage}
                    className="left"
                  >
                    {"<"}
                  </Button>
                  <Button
                    onClick={() => {
                      nextPage();
                    }}
                    disabled={!canNextPage}
                    className="right"
                  >
                    {">"}
                  </Button>
                </>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  )
}